import { CopyToClipboard as ReactCopyToClipboard } from 'react-copy-to-clipboard';
import { Tooltip } from 'ui/tooltip';
import styled from 'styled-components';

const TooltipContentContainer = styled.div`
  cursor: not-allowed;
  user-select: none;
`;

const StyledCopyToClipboard = styled(ReactCopyToClipboard)`
  user-select: none;
`;

type Props = {
  text: string;
  disabled?: boolean;
  onCopy?: () => void;
  disabledTooltip?: string;
  children?: React.ReactNode;
};

export const CopyToClipboard = ({
  children,
  text,
  onCopy,
  disabled = false,
  disabledTooltip,
}: Props) => {
  return disabled ? (
    <div>
      <Tooltip tooltipContent={disabledTooltip}>
        <TooltipContentContainer>{children}</TooltipContentContainer>
      </Tooltip>
    </div>
  ) : (
    <StyledCopyToClipboard text={text} onCopy={onCopy} options={{ format: 'text/plain' }}>
      {children}
    </StyledCopyToClipboard>
  );
};

export default CopyToClipboard;
